import React from 'react'
import googlePayRequest, {
  buildAllowedCardNetworks,
  buildTokenizationSpecification,
  buildMerchantInfo,
  describeGooglePayError,
  isGooglePayConfigError,
} from 'utils/googlePayRequest'
import classes from './styles.module.scss'
import messages from './messages'
import { message } from 'antd'
import _ from 'lodash'
import { intl, recordCountlyEvent } from 'utils'

export default class GooglePay extends React.Component {
  /**
   * Google Pay 拉不起来时的统一出口：上报 Countly 便于排查，并给用户提示，不能让按钮点了
   * 毫无反应。配置类错误（缺字段、DEVELOPER_ERROR、MERCHANT_ACCOUNT_ERROR）重试也没用，提示换支付方式；
   * 弹窗被拦截、网络抖动这类提示再试一次。
   */
  reportUnavailable = (error) => {
    const { orderNo } = this.props
    recordCountlyEvent({
      page_name: 'cashier',
      element_name: 'pay',
      event_name: 'error',
      biz_tags: {
        trade_voucher_no: orderNo,
        token: this.props.orderToken,
        pay_method: 'google_pay',
        status_code: _.get(error, 'statusCode'),
        error_message: describeGooglePayError(error),
      },
    })
    message.error(
      intl().formatMessage(isGooglePayConfigError(error) ? messages.GooglePayUnavailable : messages.GooglePayTryAgain)
    )
  }

  handleClick = async () => {
    const { payInfo, payMethod, submit, orderNo } = this.props
    // _.get 的默认值只对 undefined 生效，后端下发 null 时同样兜成空对象
    const extension = _.get(payMethod, 'payMethodExtension') || {}

    let paymentDetails
    try {
      // 后端少了 gateway / gatewayMerchantId / allowCardBrands：面板拉起来也会失败，先校验再上报 submit
      const tokenizationSpecification = buildTokenizationSpecification(extension)
      const allowedCardNetworks = buildAllowedCardNetworks(extension)

      // 真正要拉 Google Pay 面板才算一次 submit，配置缺失不计入提交量
      recordCountlyEvent({
        page_name: 'cashier',
        element_name: 'pay',
        event_name: 'submit',
        biz_tags: {
          trade_voucher_no: orderNo,
          token: this.props.orderToken,
          pay_method: 'google_pay',
        },
      })

      paymentDetails = await googlePayRequest.loadPaymentDate({
        transactionInfo: {
          totalPriceStatus: 'FINAL',
          currencyCode: _.get(payInfo, 'payAmount.currency'),
          totalPrice: _.get(payInfo, 'payAmount.amount'),
        },
        allowedCardNetworks,
        debitCredit: extension.debitCredit,
        tokenizationSpecification,
        merchantInfo: buildMerchantInfo(extension),
      })
    } catch (error) {
      // 我方配置缺失，或档案未批准当前域名、gateway 未在 Google 登记等导致的 DEVELOPER_ERROR
      this.reportUnavailable(error)
      return
    }
    // 用户主动关闭面板
    if (!paymentDetails) return

    submit({
      method: 'PAY_WITH_DEVICE',
      devicePayInfo: {
        ...paymentDetails,
        decryptType: extension.decryptType,
      },
      payMethodShortNo: _.get(payMethod, 'payMethodShortNo'),
    })
  }

  componentDidMount = () => {
    googlePayRequest.createButton('google-pay-button', this.handleClick)
  }

  render() {
    return (
      <div id='google-pay-button' className={classes.componentsPaymentMethodsGooglePay} style={{ width: '100%', height: '48px' }} />
    )
  }
}
